import { Component, OnInit, ViewContainerRef } from "@angular/core";
import { DialogRef, ModalComponent, CloseGuard } from "angular2-modal";
import { Modal, BSModalContext } from "angular2-modal/plugins/bootstrap";
import { utilityService } from "../../../sharedcomponents/commonservice/utility.service";
import { CartServiceService } from "../../../_services/dashboardservice/cart/cart-service.service";
import { AlertService } from "../../../sharedcomponents/commonservice/alert.service";
import {
  Router,
  ActivatedRoute,
  NavigationStart,
  NavigationEnd
} from "@angular/router";
import {
  AppSettings,
  enumStatusCodeList
} from "../../../sharedcomponents/_common/constants/app.constants";
import { ErrorPopupComponent } from "../../../sharedcomponents/_directive/error-popup/error-popup.component";
import { Overlay, overlayConfigFactory } from "angular2-modal";
import { AlertPopupComponent } from "../../../sharedcomponents/_directive/alert-popup/alert-popup.component";
import { InfoPopupComponent } from "../../../sharedcomponents/_directive/info-popup/info-popup.component";
import * as moment from "moment";
import { UserStateService } from "../../../_services/userservice/userstateservice";
import { TranslateService } from "ng2-translate/ng2-translate";
import { DomSanitizer } from "@angular/platform-browser";
import { ShoppingCartModal } from "./shoppingCartModal";
import { SendMoneyService } from "../../../_services/sendmoneyservice/sendmoneyservice";
import { mywalletcard } from "../../../_services/mywallet/card/mywallet.card.service";
import { mywalletstore } from "../../../_services/mywallet/store/mywallet.store.service";

@Component({
  selector: "app-shoppingcartsummary",
  templateUrl: "./shoppingcartsummary.component.html",
  providers: [
    AlertService,
    CartServiceService,
    ShoppingCartModal,
    SendMoneyService,
    mywalletcard,
    mywalletstore
  ]
})
export class ShoppingcartsummaryComponent
  implements ModalComponent<cartModalContext> {
  public shoppoingcartinfo: any;
  itemaddedtime: string;
  shareCredit = 0;
  destCountryFlag;
  sourceCountryFlag;
  constructor(
    public dialog: DialogRef<cartModalContext>,
    public modal: Modal,
    public utilserv: utilityService,
    private cartservice: CartServiceService,
    private alertService: AlertService,
    private translate: TranslateService,
    private router: Router,
    private vcRef: ViewContainerRef,
    private userStateService: UserStateService,
    public domSanitizer: DomSanitizer,
    public shoppingCartModal: ShoppingCartModal,
    public sendMoneyServiceForShoppingCart: SendMoneyService,
    private cardservice: mywalletcard,
    private storeservice: mywalletstore
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }
  populateShoppingCartModal(shoppoingcartinfo) {
    this.shoppingCartModal.TransferAmount = this.utilserv.getObjectText(shoppoingcartinfo.TransferAmount);
    this.shoppingCartModal.BeneficiaryName = this.utilserv.getObjectText(shoppoingcartinfo.BeneficiaryName);
    this.shoppingCartModal.BeneficiaryNickName = this.utilserv.getObjectText(shoppoingcartinfo.BeneficiaryNickName);

    this.shoppingCartModal.AmountLocal = this.utilserv.roundOff(this.utilserv.getObjectText(shoppoingcartinfo.AmountLocal));
    this.shoppingCartModal.TotalAmount = this.utilserv.getObjectText(shoppoingcartinfo.TotalAmount);

    this.shoppingCartModal.CountryCodeFrom = this.utilserv.getObjectText(shoppoingcartinfo.CountryCodeFrom);
    this.shoppingCartModal.CountryCodeTo = this.utilserv.getObjectText(shoppoingcartinfo.CountryCodeTo);

    this.shoppingCartModal.CurrencyCodeFrom = this.utilserv.getObjectText(shoppoingcartinfo.CurrencyCodeFrom);
    this.shoppingCartModal.CurrencyCodeTo = this.utilserv.getObjectText(shoppoingcartinfo.CurrencyCodeTo);

    this.shoppingCartModal.DeliveryMethod = this.utilserv.getObjectText(shoppoingcartinfo.DeliveryMethod);
    // Pickup type
    // this.shoppingCartModal.PickupType = this.sendMoneyServiceForShoppingCart.loadPickupTypeText(this.shoppingCartModal.DeliveryMethod);

    this.shoppingCartModal.PayingAgent = this.utilserv.getObjectText(shoppoingcartinfo.PayingAgent);
    this.shoppingCartModal.PayingAgentId = this.utilserv.getObjectText(shoppoingcartinfo.PayingAgentId);


    this.shoppingCartModal.Commission = this.utilserv.getObjectText(shoppoingcartinfo.Commission);

    this.shoppingCartModal.Rate = this.utilserv.getObjectText(shoppoingcartinfo.Rate);
    this.shoppingCartModal.RateExpired = this.utilserv.getObjectText(shoppoingcartinfo.RateExpired);

    this.shoppingCartModal.FundingId = this.utilserv.getObjectText(shoppoingcartinfo.FundingId);

    //  if (this.shoppingCartModal.FundingId != '0') { // Case for debit card
    // //  this.shoppingCartModal.DebitCardNumber = this.getcardlist(this.shoppingCartModal.FundingId);
    //  } else {

    //  }
    this.shoppingCartModal.CustomerPaymentMethod = this.utilserv.getObjectText(shoppoingcartinfo.CustomerPaymentMethod);
    this.shoppingCartModal.StoreId = this.utilserv.getObjectText(shoppoingcartinfo.StoreId);
    this.shoppingCartModal.StoreName = this.utilserv.getObjectText(shoppoingcartinfo.StoreName);

    this.shoppingCartModal.ItemAddOn = moment.unix(this.utilserv.getObjectText(shoppoingcartinfo.ItemAddOn)).format("hh:mm A L");
    this.shoppingCartModal.ItemCount = this.utilserv.getObjectText(shoppoingcartinfo.ItemCount);
    this.shoppingCartModal.MarketingBalance = this.utilserv.getObjectText(shoppoingcartinfo.MarketingBalance);

    this.shoppingCartModal.PayingAgentLocation = this.utilserv.getObjectText(shoppoingcartinfo.PayingAgentLocation);
    this.shoppingCartModal.PayingAgentLocationId = this.utilserv.getObjectText(shoppoingcartinfo.PayingAgentLocationId);

    this.shoppingCartModal.ProgramId = this.utilserv.getObjectText(shoppoingcartinfo.ProgramId);

    this.shoppingCartModal.BankId = this.utilserv.getObjectText(shoppoingcartinfo.BankId);
    this.shoppingCartModal.BankName = this.utilserv.getObjectText(shoppoingcartinfo.BankName);

    this.shoppingCartModal.AccountNumber = this.utilserv.getObjectText(shoppoingcartinfo.AccountNumber);
    this.shoppingCartModal.BankAccountType = this.utilserv.getObjectText(shoppoingcartinfo.BankAccountType);

    if (Number(this.utilserv.getObjectText(shoppoingcartinfo.ProgramId)) > 0) {
      this.shoppingCartModal.isSuperSendLabel = true;
    }

    if (this.shoppingCartModal.DeliveryMethod == "2") {
      // Bank Image
      let bandData: any = {
        BankName: this.shoppingCartModal.BankName,
        BankId: this.shoppingCartModal.BankId
      };
      this.utilserv.busy = this.sendMoneyServiceForShoppingCart
        .getBankLogo(this.shoppingCartModal)
        .subscribe(
          data => {
            if (data.HasDefaultImage == true) {
              this.shoppingCartModal.PickupCenterImage = "";
            } else {
              this.shoppingCartModal.PickupCenterImage =
                "data:image/gif;base64," + data.BankImageData;
            }
          },
          error => { }
        );
    } else {
      // Agent Image
      this.utilserv.busy = this.sendMoneyServiceForShoppingCart
        .getPayerLogo(this.shoppingCartModal)
        .subscribe(
          data => {
            if (data.HasDefaultImage == true) {
              this.shoppingCartModal.PickupCenterImage = '';
            } else {
              this.shoppingCartModal.PickupCenterImage = 'data:image/gif;base64,' + data.PayingAgentImageData;
            }
          },
          error => { }
        );
    }
  }
  OpenConfirmation() {
    const modalData: any = {};
    const _self = this;

    modalData.Title = this.translate.instant("Common_lblConfirm").toString();
    modalData.Message = this.translate
      .instant("DeleteCartItemPopup_desc")
      .toString();
    modalData.Action = this.translate.instant("Common_lblContinue").toString();
    //  this.modal.overlay.defaultViewContainer = this.vcRef;
    return this.modal
      .open(
        InfoPopupComponent,
        overlayConfigFactory({ modalData }, BSModalContext)
      )
      .then(function (obj) {
        obj.onDestroy.subscribe(data => {
          if (modalData.next == "yes") {
            const modalData: any = {};
            modalData.Title = _self.translate
              .instant("Common_lblInfo")
              .toString();
            modalData.Action = _self.translate
              .instant("Common_lblOk")
              .toString();
            _self.cartservice
              .deletecartitem(
                _self.utilserv.getObjectText(_self.shoppoingcartinfo.ItemId)
              )
              .subscribe(
                data => {
                  if (data.StatusCode == enumStatusCodeList.SUCCESS) {
                    modalData.Message = _self.translate
                      .instant("Cart_lblDeleteMessage")
                      .toString();
                  } else {
                    modalData.Message = _self.translate
                      .instant("Message_errorMessage")
                      .toString();
                  }
                  return _self.modal
                    .open(
                      AlertPopupComponent,
                      overlayConfigFactory({ modalData }, BSModalContext)
                    )
                    .then(function (obj) {
                      obj.onDestroy.subscribe(data => {
                        _self.successclosePopup(); // Success
                      });
                    });
                },
                error => {
                  //console.log("Something went wrong,Unable to delte cart Item");
                  this.closePopup();
                }
              );
          } else {
            _self.closePopup();
          }
        });
      });
  }
  ngOnInit() {
    this.shoppoingcartinfo = this.utilserv.getArray(
      this.dialog.context.element
    )[0];
    if (this.utilserv.getObjectText(this.shoppoingcartinfo.FundingId) != "0") {
      // Pay through Card
      this.getcardlist(
        this.utilserv.getObjectText(this.shoppoingcartinfo.FundingId)
      );
    } else {
      // Pay through Store
      //  this.getStoreDetail(this.utilserv.getObjectText(this.utilserv.getObjectText(this.shoppoingcartinfo.StoreId)));
      this.populateShoppingCartModal(this.shoppoingcartinfo);
    }
  }

  closePopup() {
    this.dialog.context.element.Action = false;
    this.dialog.close();
  }
  successclosePopup() {
    this.dialog.context.element.Action = true;
    this.dialog.close();
  }

  loadSourceCountryFlag(countryCode) {
    this.utilserv.busy = this.utilserv.getCountryImage(countryCode).subscribe(
      res => {
        this.sourceCountryFlag = res;
      },
      error => { }
    );
  }
  loadDestCountryFlag(countryCode) {
    this.utilserv.busy = this.utilserv.getCountryImage(countryCode).subscribe(
      res => {
        this.destCountryFlag = res;
      },
      error => { }
    );
  }
  getcardlist(FundingId) {
    const _thisCardList = this;
    this.utilserv.busy = this.cardservice
      .getcardlistservice(this.utilserv.getObjectText(FundingId))
      .subscribe(data => {
        // Intialize Image
        if (
          data.Envelope.Body.GetFundingResponse.StatusCode ==
          enumStatusCodeList.SUCCESS
        ) {
          const cardList = this.utilserv.getArray(
            data.Envelope.Body.GetFundingResponse.Fundings.Funding
          );
          if (cardList.length > 0 && cardList[0] != undefined) {
            _thisCardList.shoppingCartModal.DebitCardNumber = _thisCardList.utilserv.getObjectText(
              cardList[0].AccountNumber
            );
            _thisCardList.shoppingCartModal.DebitCardFriendlyName = _thisCardList.utilserv.getObjectText(
              cardList[0].FriendlyName
            );
            _thisCardList.populateShoppingCartModal(
              _thisCardList.shoppoingcartinfo
            );
          }
        }
      });
  }
  getStoreDetail(storeID) {
    const _self = this;
    let storeDetail;
    this.storeservice.getstorelistservice().subscribe(
      data => {
        if (
          data.Envelope.Body.StoresResponse.StatusCode ==
          enumStatusCodeList.SUCCESS
        ) {
          storeDetail = _self.utilserv
            .getArray(data.Envelope.Body.StoresResponse.Stores.StoreDetail)
            .filter(function (ele) {
              return _self.utilserv.getObjectText(ele.StoreID) == storeID;
            })[0];
          if (storeDetail != undefined && storeDetail.length > 0) {
            _self.shoppingCartModal.StoreName = _self.utilserv.getObjectText(
              storeDetail.Name
            );
          }
          _self.populateShoppingCartModal(_self.shoppoingcartinfo);
        }
      },
      error => { }
    );
  }
}
export class cartModalContext extends BSModalContext {
  element: any;
}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/shoppingcartsummary/shoppingcartsummary.component.ts